<template>
    <div style="padding:1px;">
      <hd></hd> 
      <div class="snatched">
          <el-tabs tab-position="left" style="height: 500px;">
            <el-tab-pane label="物流二维码">
              <el-input style="margin-bottom:10px;width:450px;" v-model="expressid" placeholder="请输入出库单号,英文数字长度不能超过32位，中文不能超过3个汉字">
              </el-input>
              <el-input style="width:200px;" v-model="subTitle" placeholder="副标题" label="副标题"></el-input>
              <el-button type="button" @click="generateCode(1)">生成二维码</el-button>
              <div v-show="expressqrcode" style="text-align:center;margin-top:20px;">
                <img :src="expressqrcode" style="border:1px solid;padding:5px 0"/>
              </div>
            </el-tab-pane>
            <el-tab-pane label="搜索二维码">
              <el-input v-model="keyword" placeholder="请输入搜索关键字,英文数字长度不能超过32位，中文不能超过3个汉字">
                <el-button slot="append" @click="generateCode(2)">生成二维码</el-button>
              </el-input>
              <div v-show="keywordqrcode"  style="text-align:center;margin-top:20px;">
                <img :src="keywordqrcode" style="border:1px solid;padding:5px 0"/>
              </div>
            </el-tab-pane>
            <el-tab-pane label="商品二维码">
              <el-input v-model="productid" placeholder="请输入商品货号,英文数字长度不能超过32位，中文不能超过3个汉字">
                <el-button slot="append" @click="generateCode(3)">生成二维码</el-button>
              </el-input>
              <div v-show="productqrcode" style="text-align:center;margin-top:20px;">
                <img :src="productqrcode" style="border:1px solid;padding:5px 0"/>
              </div>
            </el-tab-pane>
          </el-tabs>
          <vue-canvas-poster :widthPixels="0" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <ft class="ft"></ft>
    </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import Loading from '../../components/Loading'
import mobilefooter from '../../components/mobilefooter'
import api from '../../services/api.js'

export default {
  name: 'QrCode',
  components: {
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
    Loading: Loading
  },
  data () {
    return {
      curIndex:1,
      expressid:'',
      subTitle:'',
      productid:'',
      keyword:'',
      expressqrcode:'',
      productqrcode:'',
      keywordqrcode:'',
      painting:{},
      expresspainting:{
        width:`250px`,
        height:`350px`,
        background: '#fff',
        views: [
          {
            type: 'text',
            text: 'JoyOrders微信小程序',
            css: {
              top:'95px',
              left:'25px',
              color:'#000',
              fontSize: '20px',
              textAlign:'left',
              //padding:'10px'
            }
          },
          {
            type: 'text',
            text: '',
            css: {
              top:'135px',
              left:'25px',
              color:'#000',
              fontSize: '14px',
              textAlign:'center',
              //padding:'10px',
              maxLines:'2',
              width: '200px',
              lineHeight: '20px',
              paintingWidth:200
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，跟踪包裹 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'290px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'310px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
        ],
      },
      searchpainting:{
        width:`250px`,
        height:`350px`,
        background: '#fff',
        views: [
          {
            type: 'text',
            text: 'JoyOrders微信小程序',
            css: {
              top:'125px',
              left:'25px',
              color:'#000',
              fontSize: '20px',
              textAlign:'left',
              padding:'10px'
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，查看搜索 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'310px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
                maxLines:'2',
                width: '230px',
                lineHeight: '20px',
              }
          },
        ],
      },
      goodspainting:{
        width:`250px`,
        height:`380px`,
        background: '#fff',
        views: [
          {
            type: 'image',
            url: '',
            css: {
              width:`250px`,
              height:`250px`,
              mode:'aspectFill',
              left:'0',
              top: '0'
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，下单购买 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'280px',
                color:'#000',
                fontSize: '25px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'290px',
                left: '80px',
                color:'#000',
                fontSize: '15px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'318px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
                maxLines:'2',
                width: '230px',
                lineHeight: '20px',
              }
          },
        ],
      },
    }
  },
  mounted () {
    
  },
  methods: {
    fail(err) {
      console.log('fail', err)
    },
    success(src) {
     switch(this.curIndex){
       case 1:
         this.expressqrcode=src;
         break;
       case 2:
         this.keywordqrcode=src;
         break;
       case 3:
         this.productqrcode=src;
         break;
     }
    },
    generateCode(index){
      this.curIndex=index;
      let res={}
      let params={}
      let goods={}
      switch(index){
        case 1:
          params={
						page: 'pages/order/qrcodeExpress/qrcodeExpress',
						is_hyaline: true,
						scene: this.expressid
					}
          api.post(this, {
              path: 'good.php',
              data: params,
              loading: 'loading',
              api: 'create_qr_code'
          }).then((res)=>{
            this.$set(this.expresspainting.views[1], 'text', this.subTitle);
            this.$set(this.expresspainting.views[5], 'url', res.body);
            this.$set(this.expresspainting.views[6], 'text', `出库单号：`);
            this.$set(this.expresspainting.views[7], 'text', `${this.expressid}`);
            this.painting=JSON.parse(JSON.stringify(this.expresspainting))
          })
          break;
        case 2:
          params={
						page: 'pages/search/category',
						is_hyaline: true,
						scene: encodeURIComponent(this.keyword).replace(/%/g,';')
					}
          api.post(this, {
              path: 'good.php',
              data: params,
              loading: 'loading',
              api: 'create_qr_code'
          }).then((res)=>{
            this.$set(this.searchpainting.views[4], 'url', res.body);
            this.$set(this.searchpainting.views[5], 'text', `查看‘${this.keyword}’的搜索结果`);
            this.painting=JSON.parse(JSON.stringify(this.searchpainting))
          })
          break;
        case 3:
          //goods=await api.getGoodsDetailBySku(this,{sku:this.productid});
          api.get(this, {
            path: 'good.php',
            api: 'get_detail_by_sku',
            params: {
              sku:this.productid
            },
            loading: 'loading'
          }).then((goods)=>{
            console.log(goods)
            goods=goods.body;
            params={
              page: 'pages/product-detail/product-detail',
              is_hyaline: true,
              scene: goods.result.id
            }
            api.post(this, {
                path: 'good.php',
                data: params,
                loading: 'loading',
                api: 'create_qr_code'
            }).then((res)=>{
              this.$set(this.goodspainting.views[0], 'url', goods.result.cover_image.small);
              this.$set(this.goodspainting.views[4], 'url', res.body);
              this.$set(this.goodspainting.views[5], 'text', `${goods.result.currency_symbol}${goods.result.discounted_price}`);
              this.$set(this.goodspainting.views[6], 'text', `${goods.result.currency}`);
              if(+goods.result.discounted_price>=1000){
                this.$set(this.goodspainting.views[6].css, 'left', `100px`);
              }
              else if(+goods.result.discounted_price>=100){
                this.$set(this.goodspainting.views[6].css, 'left', `90px`);
              }
              else if(+goods.result.discounted_price>=10){
                this.$set(this.goodspainting.views[6].css, 'left', `85px`);
              }
              this.$set(this.goodspainting.views[7], 'text', goods.result.name_cn || goods.result.name);
              this.painting=JSON.parse(JSON.stringify(this.goodspainting))

            })
          })
          break;
      }
    },
  },
}

</script>
<style scoped lang="scss">
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;
}
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                padding-left: 0 !important;

                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/qrcode.vue